import { render, staticRenderFns } from "./Pdf-9.vue?vue&type=template&id=c0b3e08c"
import script from "./Pdf-9.vue?vue&type=script&lang=js"
export * from "./Pdf-9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports